import { getIDToken } from "../utils/utils";
import * as config from "../config.js";

export const getClientWorkflows = async (client_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  console.log("!!! GETTING WORKFLOWS FOR CLIENT: ", client_id);
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/workflow/client/${client_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    }
  );

  const workflows = await response.json();
  return workflows;
};

export const getInferenceWorkflows = async () => {
  // We dispatch requestLogin to kickoff the call to the API
  console.log("!!! GETTING INFERENCE WORKFLOWS");
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/workflow/type/inference`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    }
  );

  const workflows = await response.json();
  return workflows;
};

export const getWorkflowArchives = async (workflow) => {
  // We dispatch requestLogin to kickoff the call to the API
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/workflow/archives/${workflow.public_id}`,
    {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    }
  );

  const results = await response.json();
  console.log("!! ARCHIVES: ", results);
  return results;
};

export const getWorkflow = async (public_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/workflow/${public_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    }
  );

  const workflow = await response.json();
  return workflow;
};

export const getWorkflowArchive = async (public_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/workflow/archive/${public_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    }
  );

  const workflowArchive = await response.json();
  return workflowArchive;
};

export const saveWorkflow = async (workflow) => {
  if (workflow?.archive_id) {
    console.log("!!! CAN'T SAVE ARCHIVE: ", workflow.archive_id);
    return;
  }

  // We dispatch requestLogin to kickoff the call to the API
  const method = workflow.id ? "PUT" : "POST";
  const url = workflow.id
    ? `${config.REST_SERVER_URL}/admin/workflow/${workflow.public_id}`
    : `${config.REST_SERVER_URL}/admin/workflow`;
  const response = await fetch(url, {
    method: method,
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
    body: JSON.stringify(workflow),
  }).catch((error) =>
    console.error(`Something was wrong. Try again: ${error}`, false)
  );

  const workflowResponse = await response.json();
  return workflowResponse;
};

export const getNode = async (public_id, archive_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  const url = archive_id
    ? `${config.REST_SERVER_URL}/admin/node/archive/${public_id}/${archive_id}`
    : `${config.REST_SERVER_URL}/admin/node/${public_id}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) =>
    console.error(`Something was wrong. Try again: ${error}`, false)
  );

  const node = await response.json();
  return node;
};
